import axios from "axios";
import React, { useState, useEffect } from "react";
import { DownloadTableExcel } from "react-export-table-to-excel";
import moment from "moment";
import ClientDetailCTLoanDetail from "../../ClientDetailCTLoanDetail";
import EmployerDetails from "../../EmployerDetails";
import { APIURL, APIURLCOT } from "../../../Config";

function Outstanding() {
  const token = localStorage.getItem("token");
  const cid = localStorage.getItem("corporateId");
  const [showSearchEmp, setShowSearchEmp] = useState(false);
  const [corpid, setCorpid] = useState();

  const [option, setOption] = useState("all");
  const [list, setClist] = useState([]);
  const [totalUnpaid, setTotalUnpaid] = useState();
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [empSummary, setEmpSummary] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [isLoader, setIsLoader] = useState(false);
  const tableEmpSummaryModel = React.useRef(null);
  const tableEmpOutstanding = React.useRef(null);
  const [manageEmpStatus, setManageEmpStatus] = useState(true);
  const [apiKey, setApiKey] = useState("");
  const [corporateid, setCorporateId] = useState(0);
  const [width, setWidth] = React.useState(window.innerWidth < 768);

  useEffect(() => {
    setManageEmpStatus(false);
    getEnachSummaryModel();
  }, [option]);

  useEffect(() => {
    getClist();
  }, []);

  const getClist = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/List`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const data = response?.data; // Array of objects
        if (data && data.length > 0) {
          setClist(data); // Update state with the list
          setCorporateId(data[0]?.corporateId); // Set corporateId from the first item
        }
        setIsLoader(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const getEnachSummaryModel = () => {
    // const data = { email: email, status: month };
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getEnachSummaryModel/${option}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("response", response);
        setEmpSummary(response?.data);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  const ManageEmpSummary = (key, status) => {
    setIsLoader(true);
    let sAmount = [];
    axios
      .request(
        `${APIURLCOT}/${key}/${
          option == "all" ? 0 : option == "cpc" ? 1 : 2
        }/${status}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setEmpData(response?.data);
        setIsLoader(false);
        response.data.map((row, index) => {
          sAmount.push(row.amount);
        });
        const total = sAmount.reduce((a, b) => a + b, 0);
        setTotalUnpaid(total.toFixed(2));
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  return (
    <div className={width ? "" : "p-3"}>
      <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
        <li
          className={width ? "nav-item mt-2" : "nav-item"}
          role="presentation"
        >
          <button
            className="nav-link active tab-item"
            id="outstanding-tab"
            data-bs-toggle="tab"
            data-bs-target="#outstanding"
            type="button"
            role="tab"
            aria-controls="outstanding"
            aria-selected="true"
          >
            Outstanding
          </button>
        </li>
      </ul>
      <div className="card mt-3">
        {showSearchEmp ? (
          <>
            <div className="p-3 d-flex justify-content-start mt-3">
              <button
                className="btn btn-secondary"
                style={{ width: "100px" }}
                onClick={() => {
                  setShowSearchEmp(false);
                }}
              >
                Back
              </button>
            </div>
            <div className="p-3 pt-2">
              <EmployerDetails corpid={corpid} />
            </div>
          </>
        ) : showSearch ? (
          <>
            <div className="p-3 d-flex justify-content-start mt-3">
              <button
                className="btn btn-secondary"
                style={{ width: "100px" }}
                onClick={() => {
                  setShowSearch(false);
                }}
              >
                Back
              </button>
            </div>
            <div className="p-3 pt-2">
              <ClientDetailCTLoanDetail lid={lid} />
            </div>
          </>
        ) : (
          <>
            <div className="">
              <div className="p-3 ">
                {!manageEmpStatus && (
                  <>
                    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                      {/* Download Button */}
                      <div className="mb-3 mb-md-0">
                        <DownloadTableExcel
                          filename="EmpOutstandingSummary"
                          sheet="users"
                          currentTableRef={tableEmpSummaryModel.current}
                        >
                          <button
                            className="btn btn-success"
                            style={{
                              width: "120px",
                              backgroundColor: "black",
                            }}
                          >
                            Download
                          </button>
                        </DownloadTableExcel>
                      </div>

                      {/* Select Dropdown */}
                      <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                        <div className="ml-0 ml-md-2">
                          <select
                            className="form-select w-auto"
                            id="options"
                            onChange={(e) => setOption(e.target.value)}
                            value={option}
                          >
                            <option value="all">ALL</option>
                            <option value="cpc">CPC</option>
                            <option value="openingmarket">Open Market</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-striped mt-3">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Due Month</th>
                            <th style={{ textAlign: "center" }}>Due Case</th>
                            <th style={{ textAlign: "center" }}>Due</th>
                            <th style={{ textAlign: "center" }}>
                              Today Collection
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Collection Count
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Collection Amt
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Outstanding Count
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Outstanding Amt
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Late Fee Amount
                            </th>
                            <th style={{ textAlign: "center" }}>Unpaid</th>
                            <th style={{ textAlign: "center" }}>Unpaid Amt</th>
                          </tr>
                        </thead>
                        <tbody>
                          {empSummary.length > 0 ? (
                            empSummary.map((item, i) => (
                              <tr key={i}>
                                <td style={{ textAlign: "center" }}>{i + 1}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.due_month}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.due_case}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.due_case) {
                                      setManageEmpStatus(true);
                                      ManageEmpSummary("getSummaryDueCase", i);
                                      setApiKey("getSummaryDueCase");
                                    }
                                  }}
                                >
                                  {item.due}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.todaycollection}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.collectionc}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.due_case) {
                                      setManageEmpStatus(true);
                                      ManageEmpSummary(
                                        "geSummaryCollectionTodayMonth",
                                        i
                                      );
                                      setApiKey(
                                        "geSummaryCollectionTodayMonth"
                                      );
                                    }
                                  }}
                                >
                                  {item.coll}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.outstandingcase}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.outstandingamount) {
                                      setManageEmpStatus(true);
                                      ManageEmpSummary(
                                        "getSummaryoutstanding",
                                        i
                                      );
                                      setApiKey("getSummaryoutstanding");
                                    }
                                  }}
                                >
                                  {item.outstandingamount}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.latefee) {
                                      setManageEmpStatus(true);
                                      ManageEmpSummary("getSummarylatefee", i);
                                      setApiKey("getSummarylatefee");
                                    }
                                  }}
                                >
                                  {item.latefee || 0}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.unpaid}
                                </td>
                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.due_case) {
                                      setManageEmpStatus(true);
                                      ManageEmpSummary("getSummaryUnpaid", i);
                                      setApiKey("getSummaryUnpaid");
                                    }
                                  }}
                                >
                                  {item.unpaidamount}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="11" style={{ textAlign: "center" }}>
                                {isLoader ? (
                                  <div
                                    className="spinner-border text-success"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  "No data available"
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {manageEmpStatus && (
                  <div>
                    <div className="d-flex justify-content-between align-items-center">
                      {/* Left side buttons */}
                      <div className="d-flex">
                        <DownloadTableExcel
                          filename="EmpOutstandingSummary"
                          sheet="users"
                          currentTableRef={tableEmpOutstanding.current}
                        >
                          <button
                            className="btn btn-success mb-0 mb-md-0 mt-0 mr-3"
                            style={{
                              width: "120px",
                              backgroundColor: "black",
                            }}
                          >
                            Download
                          </button>
                        </DownloadTableExcel>

                        <button
                          className="btn btn-secondary"
                          onClick={() => setManageEmpStatus(false)}
                          style={{ width: "80px" }}
                        >
                          Back
                        </button>
                      </div>

                      {/* Total Unpaid Amount */}
                      {apiKey === "getSummaryUnpaid" && (
                        <div className="d-flex align-items-center">
                          <p className="mb-0 font-weight-bold">
                            Total Unpaid Amount: {totalUnpaid}
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="table-responsive">
                      <table className="table table-striped mt-3">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Name</th>
                            <th style={{ textAlign: "center" }}>Loan Id</th>
                            {/* <th style={{ textAlign: "center" }}>
                              Employer Name
                            </th> */}
                            <th style={{ textAlign: "center" }}>Mobile No</th>
                            {apiKey === "getSummarylatefee" && (
                              <th style={{ textAlign: "center" }}>
                                Outstanding Amount
                              </th>
                            )}

                            {apiKey === "getSummaryDueCase" && (
                              <th style={{ textAlign: "center" }}>Due Date</th>
                            )}
                            {apiKey === "geSummaryCollectionTodayMonth" && (
                              <th style={{ textAlign: "center" }}>
                                Collection Date
                              </th>
                            )}
                            {apiKey === "getSummaryoutstanding" && (
                              <th style={{ textAlign: "center" }}>
                                Outstanding Date
                              </th>
                            )}
                            {apiKey === "getSummaryUnpaid" && (
                              <th style={{ textAlign: "center" }}>
                                Unpaid Date
                              </th>
                            )}

                            {apiKey === "getSummarylatefee" && (
                              <th style={{ textAlign: "center" }}>
                                Late Fee Date
                              </th>
                            )}
                            {apiKey === "getSummaryDueCase" && (
                              <th style={{ textAlign: "center" }}>
                                Due Amount
                              </th>
                            )}
                            {apiKey === "geSummaryCollectionTodayMonth" && (
                              <th style={{ textAlign: "center" }}>
                                Collection Amount
                              </th>
                            )}
                            {apiKey === "getSummaryUnpaid" && (
                              <th style={{ textAlign: "center" }}>
                                Unpaid Amount
                              </th>
                            )}
                            {apiKey === "getSummaryoutstanding" && (
                              <th style={{ textAlign: "center" }}>
                                Outstanding Amount
                              </th>
                            )}
                            {apiKey === "getSummarylatefee" && (
                              <th style={{ textAlign: "center" }}>
                                Late Fee Amount
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {empData.length > 0 ? (
                            empData.map((item, i) => (
                              <tr key={i}>
                                <td style={{ textAlign: "center" }}>{i + 1}</td>

                                <td>{item.name}</td>

                                <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.loanid) {
                                      setLid(item.loanid);
                                      setShowSearch(true);
                                    }
                                  }}
                                >
                                  {item.loanid}
                                </td>
                                {/* <td
                                  style={{
                                    color: "blue",
                                    cursor: "pointer",
                                    textAlign: "center",
                                  }}
                                  onClick={() => {
                                    if (item.code) {
                                      setCorpid(item?.corpid);
                                      setShowSearchEmp(true);
                                    }
                                  }}
                                >
                                  {item.code}
                                </td> */}
                                <td style={{ textAlign: "center" }}>
                                  {item.mobileno}
                                </td>
                                {apiKey === "getSummarylatefee" && (
                                  <td style={{ textAlign: "center" }}>
                                    {item.outstanding}
                                  </td>
                                )}

                                <td style={{ textAlign: "center" }}>
                                  {moment(item.txndate).format("DD-MM-YYYY")}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {item.amount}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" style={{ textAlign: "center" }}>
                                {isLoader ? (
                                  <div
                                    className="spinner-border text-success"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                ) : (
                                  "No data available"
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <table
              className="table table-striped mt-3 "
              style={{ display: "none" }}
              ref={tableEmpSummaryModel}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Sr. No</th>
                  <th style={{ textAlign: "center" }}>Due Month</th>
                  <th style={{ textAlign: "center" }}>Due Case</th>
                  <th style={{ textAlign: "center" }}>Due</th>
                  <th style={{ textAlign: "center" }}>Today Collection</th>
                  <th style={{ textAlign: "center" }}>Collection Count</th>
                  <th style={{ textAlign: "center" }}>Collection Amt</th>
                  <th style={{ textAlign: "center" }}>Outstanding Count</th>
                  <th style={{ textAlign: "center" }}>Outstanding Amount</th>
                  <th style={{ textAlign: "center" }}>Unpaid</th>
                  <th style={{ textAlign: "center" }}>Unpaid Amt</th>
                  <th style={{ textAlign: "center" }}>Late Fee Amount</th>
                </tr>
              </thead>
              <tbody>
                {empSummary.length > 0 ? (
                  empSummary.map((item, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "center" }}>{i + 1}</td>
                      <td style={{ textAlign: "center" }}>{item.due_month}</td>
                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.due_case) {
                            setManageEmpStatus(true);
                            ManageEmpSummary("getSummaryDueCase", i);
                            setApiKey("getSummaryDueCase");
                          }
                        }}
                      >
                        {item.due_case}
                      </td>
                      <td style={{ textAlign: "center" }}>{item.due}</td>
                      <td style={{ textAlign: "center" }}>
                        {item.todaycollection}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.collectionc}
                      </td>
                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.due_case) {
                            setManageEmpStatus(true);
                            ManageEmpSummary(
                              "geSummaryCollectionTodayMonth",
                              i
                            );
                            setApiKey("geSummaryCollectionTodayMonth");
                          }
                        }}
                      >
                        {item.coll}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.outstandingcase}
                      </td>
                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.outstandingamount) {
                            setManageEmpStatus(true);
                            ManageEmpSummary("getSummaryoutstanding", i);
                            setApiKey("getSummaryoutstanding");
                          }
                        }}
                      >
                        {item.outstandingamount}
                      </td>

                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.due_case) {
                            setManageEmpStatus(true);
                            ManageEmpSummary("getSummaryUnpaid", i);
                            setApiKey("getSummaryUnpaid");
                          }
                        }}
                      >
                        {item.unpaid}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.unpaidamount}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {item.latefee || 0}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="11" style={{ textAlign: "center" }}>
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "No data available"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <table
              className="table table-striped mt-3 "
              style={{ display: "none" }}
              ref={tableEmpOutstanding}
            >
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>Sr. No</th>
                  <th style={{ textAlign: "center" }}>Name</th>
                  <th style={{ textAlign: "center" }}>Loan Id</th>
                  {/* <th style={{ textAlign: "center" }}>Employer Name</th> */}
                  <th style={{ textAlign: "center" }}>Mobile No</th>
                  {apiKey === "getSummarylatefee" && (
                    <th style={{ textAlign: "center" }}>Outstanding Amount</th>
                  )}

                  {apiKey === "getSummaryDueCase" && (
                    <th style={{ textAlign: "center" }}>Due Date</th>
                  )}
                  {apiKey === "geSummaryCollectionTodayMonth" && (
                    <th style={{ textAlign: "center" }}>Collection Date</th>
                  )}
                  {apiKey === "getSummaryoutstanding" && (
                    <th style={{ textAlign: "center" }}>Outstanding Date</th>
                  )}
                  {apiKey === "getSummaryUnpaid" && (
                    <th style={{ textAlign: "center" }}>Unpaid Date</th>
                  )}

                  {apiKey === "getSummarylatefee" && (
                    <th style={{ textAlign: "center" }}>Late Fee Date</th>
                  )}
                  {apiKey === "getSummaryDueCase" && (
                    <th style={{ textAlign: "center" }}>Due Amount</th>
                  )}
                  {apiKey === "geSummaryCollectionTodayMonth" && (
                    <th style={{ textAlign: "center" }}>Collection Amount</th>
                  )}
                  {apiKey === "getSummaryUnpaid" && (
                    <th style={{ textAlign: "center" }}>Unpaid Amount</th>
                  )}
                  {apiKey === "getSummaryoutstanding" && (
                    <th style={{ textAlign: "center" }}>Outstanding Amount</th>
                  )}
                  {apiKey === "getSummarylatefee" && (
                    <th style={{ textAlign: "center" }}>Late Fee Amount</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {empData && empData.length > 0 ? (
                  empData.map((item, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: "center" }}>{i + 1}</td>

                      <td>{item.name}</td>

                      <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.loanid) {
                            setLid(item.loanid);
                            setShowSearch(true);
                          }
                        }}
                      >
                        {item.loanid}
                      </td>
                      {/* <td
                        style={{
                          color: "blue",
                          cursor: "pointer",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          if (item.code) {
                            setCorpid(item?.corpid);
                            setShowSearchEmp(true);
                          }
                        }}
                      >
                        {item.code}
                      </td> */}
                      <td style={{ textAlign: "center" }}>{item.mobileno}</td>
                      {apiKey === "getSummarylatefee" && (
                        <td style={{ textAlign: "center" }}>
                          {item.outstanding}
                        </td>
                      )}

                      <td style={{ textAlign: "center" }}>
                        {moment(item.txndate).format("DD-MM-YYYY")}
                      </td>
                      <td style={{ textAlign: "center" }}>{item.amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" style={{ textAlign: "center" }}>
                      {isLoader ? (
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "No data available"
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
}
export default Outstanding;
